<template>
	<div id="renderContainer" class="render" :style="{background: '#' + backgroundProp}">
		<div @mousedown="canvasDragStart" class="canvas" :style="{transform: 'translate3d(' + canvas.endx + 'px, ' + canvas.endy + 'px, 0)'}">
			<!-- <img class="image shadow" :src="'https://s3-eu-west-1.amazonaws.com/bisque-media/renders/DEL_80_60/DEL_80_60_Shadow_' + settings.view + '.1.png'" alt="" :style="{transform: 'scale(' + zoomScale + ')'}" style="transform-origin: center center;"> -->
			<img class="image radiator" :src="'https://s3-eu-west-1.amazonaws.com/bisque-media/renders/' + renderCodeProp + '/' + renderCodeProp + '_' + finishProp.renderReference + '_' + settings.view + '.png'" alt="" :style="{transform: 'scale(' + zoomScale + ')'}" style="transform-origin: center center;" @error="radiatorRenderError">
			<!-- <img class="image heater" src="/images/1px.gif" alt="" :style="{transform: 'scale(' + zoomScale + ')'}" style="transform-origin: center center;"> -->
			<!-- <img class="image valves" :src="'https://s3-eu-west-1.amazonaws.com/bisque-media/renders/DEL_80_60/DEL_80_60_BTH_VSS_MAT5_' + settings.view + '.1.png'" alt="" :style="{transform: 'scale(' + zoomScale + ')'}" style="transform-origin: center center;"> -->
		</div>

		<div class="controls">
			<ul class="views">
				<li @click="viewSelected('Front')" class="view btn">Front</li>
				<li @click="viewSelected('Side')" class="view btn">Side</li>
			</ul>
			<ul class="zooms">
				<li @click="zoomIn" class="zoom btn">+</li>
				<li @click="zoomOut" class="zoom btn">-</li>
			</ul>
			<ul class="backgrounds">
				<li @click="toggleBackgroundPicker" class="background-colour btn">Background colour</li>
			</ul>
			<div :class="{hidden: !backgroundPickerOpen}" class="colour-picker">
				<ColorPicker :width="195" :height="195" :disabled="!backgroundPickerOpen" :startColor="backgroundProp" @color-change="onBackgroundChanged" />
			</div>

			<!-- <div class="js-colorpicker"><div class="farbtastic"><div class="color" style="background-color: rgb(0, 182, 255);"></div><div class="wheel"></div><div class="overlay"></div><div class="h-marker marker" style="left: 72px; top: 177px;"></div><div class="sl-marker marker" style="left: 112px; top: 98px;"></div></div></div> -->
		</div>
	</div>
</template>

<script>
	import ColorPicker from 'vue-color-picker-wheel';

	const MAX_ZOOM = 5;

	export default {
			props: ['viewProp', 'zoomProp', 'backgroundProp', 'renderCodeProp', 'finishProp'],
			data() {
				return {
					settings: {
						view: '',
						zoom: 1,
						background: '',
					},
					canvas: {
						x: 0,
						y: 0,
						startx: 0,
						starty: 0,
						endx: 0,
						endy: 0,
					},
					backgroundPickerOpen: false,
				};
			},
			methods: {
				zoomIn: function() {
					if (this.settings.zoom >= MAX_ZOOM) return;
					this.settings.zoom++;
					this.$emit('renderSettingsChanged', this.settings);
				},
				zoomOut: function() {
					if (this.settings.zoom <= 1) return;
					this.settings.zoom--;
					this.$emit('renderSettingsChanged', this.settings);
				},
				viewSelected: function(view) {
					this.settings.view = view;
					this.$emit('renderSettingsChanged', this.settings);
				},
				canvasDragStart: function(event) {
					event.preventDefault();
					this.canvas.startx = event.clientX;
					this.canvas.starty = event.clientY;
					document.onmousemove = this.canvasDragging
					document.onmouseup = this.canvasDragEnd
				},
				canvasDragging: function(event) {
					event.preventDefault();
					this.canvas.x = this.canvas.startx - event.clientX;
					this.canvas.y = this.canvas.starty - event.clientY;
					this.canvas.startx = event.clientX;
					this.canvas.starty = event.clientY;
					this.canvas.endx = this.canvas.endx - this.canvas.x;
					this.canvas.endy = this.canvas.endy - this.canvas.y;
				},
				canvasDragEnd: function() {
					document.onmouseup = null;
					document.onmousemove = null;
				},
				toggleBackgroundPicker: function() {
					this.backgroundPickerOpen = !this.backgroundPickerOpen;
				},
				onBackgroundChanged: function(colour) {
					let newColour = colour.replace('#','');
					if (newColour == this.settings.background) return;
					this.settings.background = newColour;
					this.$emit('renderSettingsChanged', this.settings);
				},
				radiatorRenderError: function(event) {
					this.$emit('radiatorRenderError', event);
				}
			},
			mounted: function () {
				this.settings.view = this.viewProp;
				this.settings.zoom = this.zoomProp;
				this.settings.background = this.backgroundProp;
			},
			computed: {
				zoomScale: function() {
					return ((this.settings.zoom - 1) * 0.5) + 1;
				},
			},
			components: {
				ColorPicker,
			}
	};
</script>

<style scoped>
	.render {
		position: relative;
		padding: 100% 0 0;
		height: 0;
		overflow: hidden;
	}

	.canvas {
		width: 100%;
		padding-top: 100%;
		position: absolute;
		top: 0;
		left: 0;
		cursor: move;
	}

	.controls {
		position: absolute;
		width: 110px;
		top: 18px;
		left: 18px;
		text-align: center;
		color: #fff;
	}

	.btn {
		font-size: 12px;
		font-family: Arial, sans-serif;
		background: rgba(0, 0, 0, 0.25);
		transition: all 150ms ease;
		margin: 0 0 9px;
		width: 50%;
		padding: 3px 0;
		cursor: pointer;
	}

	.btn:hover {
		color: #f4d900;
		background: rgba(0, 0, 0, 0.35);
		transition: all 150ms ease;
	}

	.views,
	.zooms,
	.backgrounds {
		display: flex;
		justify-content: space-between;
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.zoom {
		width: calc(50% - 0.5rem);
	}

	.background-colour {
		width: 100%;
		margin: 0;
	}

	.colour-picker {
		background: rgba(0, 0, 0, 0.25);
		padding: 3px;
		width: 201px;
		transition: all 150ms ease;
	}

	.hidden {
		opacity: 0;
		pointer-events: none;
		transition: all 150ms ease;
	}

	.image {
		position: absolute;
		top: 0;
		left: 0;
		transition: all 0.25s ease-in-out;
		backface-visibility: visible;
		transform-style: preserve-3d;
		width: 100%;
		max-width: 100%;
		height: auto;
		display: block;
		border-style: none;
	}
</style>
